const RANK = { info: 1, warning: 2, error: 3 };
/**
 * The worst severity among the findings. A finding without its own severity counts as
 * `fallback`. `undefined` when there are no findings.
 */
export function worstSeverity(findings, fallback) {
    var _a;
    let worst = undefined;
    for (const f of findings) {
        const sev = (_a = f.severity) !== null && _a !== void 0 ? _a : fallback;
        if (worst === undefined || RANK[sev] > RANK[worst])
            worst = sev;
        if (worst === "error")
            break;
    }
    return worst;
}
export function isWorseOrEqual(a, b) {
    return RANK[a] >= RANK[b];
}
